import { CHARACTER_TYPE } from "@/enums/character_type";

export interface Avatar {
  id?: number;
  url: string;
  characterType: CHARACTER_TYPE;
}

export const isCharacter = (avatar: Avatar) => {
  return avatar.characterType === CHARACTER_TYPE.COURSE_CHARACTER;
};
